







































































































































































































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import Dropdown from '@/shared/dropdown/dropdown.component.vue';
import Combobox from '@/shared/combobox/combobox.component.vue';
import FilterFields from '@/domain/project/filter-fields.entity';
import UserService from '@/domain/user/user.service';
import Survey from '@/domain/survey/survey.entity';
import Rules from '@/shared/utils/rules';
import WorkItemSummary from '@/domain/work-item/work-item-summary.entity';
import SurveyService from '@/domain/survey/survey.service';
import snackBarService from '@/shared/snackbar/snackbar.service';
import WorkItemService from '@/domain/work-item/work-item.service';
import DatePicker from '@/shared/date-picker/date-picker.component.vue';
import ProjectUserStore from '@/domain/project/project-with-members.store';
import { DeliveryObject } from '@/domain/survey/delivery-object-interface';
import ModalConfirm from '@/shared/modals/modal-confirm.component.vue';
import OverlayLoader from '@/shared/overlay-loader/overlay-loader.component.vue';

const qs: any = require('qs');

interface SelectableWorkItemSummary extends WorkItemSummary {
  selected: boolean;
}

@Component({
  components: {
    DatePicker, ModalConfirm, OverlayLoader, Dropdown, Combobox,
  },
})
export default class SurveyComponent extends Vue {
  private projectsStore = getModule(ProjectUserStore);

  private selectAll: boolean = false;

  private deliveryObject: DeliveryObject = {
    id: '',
    singleDelivery: false,
    isMandatory: true,
    link: '',
    expirationDate: new Date(),
    demandName: '',
    deliverables: [],
  };

  tab: number = 0;

  updateSelectedWorkItems: number = 1;

  get selectAllLabel(): string {
    return this.selectAll ? 'Desmarcar todos os entregáveis' : 'Selecionar todos os entregáveis';
  }

  surveyData: Survey = new Survey();

  emailLanguages: string[] = ['Português (PT-BR)', 'Inglês', 'Espanhol'];

  private emailLocaleMap: { [key: string]: string } = {
    'Português (PT-BR)': 'pt',
    Inglês: 'en',
    Espanhol: 'es',
  };

  get emailLocale(): string {
    return this.emailLocaleMap[this.surveyData.language] || 'pt';
  }

  emailT(key: string): string {
    const messages = this.$i18n.getLocaleMessage(this.emailLocale) as { [key: string]: string };
    return messages[key] || key;
  }

  rules: Rules = new Rules();

  valid: boolean = false;

  private searchInput: string = '';

  private demandName: string = '';

  private oldDemandName: string = '';

  private showSnackbar: boolean = false;

  private deliveryDateFrom: string = '';

  private deliveryDateTo: string = '';

  private disableDeliveryName = false;

  private dialogModal: boolean = false;

  private filterFields = new FilterFields();

  projectId: string = '';

  projectControlName: string = '';

  projectControlNameList: string[] = [];

  assignedToIds: string[] = [];

  assignedTo: string[] = [];

  assignedToSearch: string = '';

  workItems: WorkItemSummary[] = [];

  loadingWorkItems: boolean = false;

  hasError: boolean = false;

  isCopyLinkButtonDisabled: boolean = false;

  showAddWorkItemModal: boolean = false;

  loadingGenerateLink: boolean = false;

  workItemsSelectedList: WorkItemSummary[] = [];

  shouldReloadAssignedTo: boolean = false;

  workItemsSaved: WorkItemSummary[] = [];

  private loadMembers() {
    UserService.searchAllActiveUsers()
      .then((users) => {
        this.filterFields.members = users;
      });
  }

  created() {
    this.loadMembers();
  }

  get searchedWorkItems(): WorkItemSummary[] {
    if (this.searchInput.length < 3) {
      return this.workItems;
    }
    if (this.searchInput === '') {
      return this.workItems;
    }
    return this.workItems.filter(item => item.title.toLowerCase()
      .includes(this.searchInput.toLowerCase()));
  }

  generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      // eslint-disable-next-line no-bitwise
      const r = (Math.random() * 16) | 0;
      // eslint-disable-next-line no-bitwise
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  private async copyLink() {
    this.loadingGenerateLink = true;
    this.isCopyLinkButtonDisabled = true;
    this.hasError = false;
    this.showSnackbar = false;

    this.deliveryObject.link = `${this.surveyData.singleDelivery ? process.env.VUE_APP_SEPARATE_SURVEY_URL : process.env.VUE_APP_SURVEY_URL}/${this.deliveryObject.id}`;
    this.deliveryObject.demandName = this.demandName && this.demandName.trim() !== '' ? this.demandName : null;

    try {
      await SurveyService.createLinkSurvey(this.deliveryObject);
      await navigator.clipboard.writeText(this.deliveryObject.link).then(() => {
        this.delayedAction();
        this.hasError = false;
        this.showSnackbar = true;
      });
    } catch (error) {
      this.hasError = true;
      this.showSnackbar = true;
      this.delayedAction();
    } finally {
      this.loadingGenerateLink = false;
    }
  }

  private handleDateFromInput(date: string): void {
    this.updateDeliveryDate(date, 'from');
  }

  private handleDateToInput(date: string): void {
    this.updateDeliveryDate(date, 'to');
  }

  private reloadAssignedToInput() {
    this.assignedTo = [];
    this.assignedToIds = [];
    this.shouldReloadAssignedTo = true;
    this.workItemsSelectedList = [];
  }

  private updateDeliveryDate(date: string, type: 'from' | 'to'): void {
    if (type === 'from') {
      this.deliveryDateFrom = date;
    } else if (type === 'to') {
      this.deliveryDateTo = date;
    }
    this.reloadAssignedToInput();
    this.loadWorkItems();
  }

  updateProjectId(projectId: string) {
    this.projectId = projectId;
    if (this.projectControlNameList.length > 0) {
      this.projectControlName = '';
      this.projectControlNameList = [];
    }
    this.reloadAssignedToInput();
    this.loadWorkItems();
  }

  updateProjectControlName(projectControlName: string) {
    this.projectControlName = projectControlName;
    this.reloadAssignedToInput();
    this.loadWorkItems();
  }

  updateAssignedTo(userNames: string[]) {
    const validUserNames = userNames.filter(
      userName => this.handleWorkItemUserNames.includes(userName),
    );
    if (validUserNames.length !== userNames.length) {
      this.assignedTo = validUserNames;
    }
    const workitems = this.getWorkItemByAssignedToName(validUserNames);
    this.assignedToIds = [...new Set(workitems.map(w => w.assignedTo.id))];
    this.assignedToSearch = '';
    this.loadWorkItems();
  }

  private executeEmailSend() {
    this.isCopyLinkButtonDisabled = true;

    const surveyData = new Survey({
      ...this.surveyData,
      deliveryName: this.getDemandNameOrWorkItemNames(),
      workItems: this.selectedWorkItems.map(it => it.id),
    });

    this.deliveryObject.link = `${this.surveyData.singleDelivery ? process.env.VUE_APP_SEPARATE_SURVEY_URL : process.env.VUE_APP_SURVEY_URL}/${this.deliveryObject.id}`;
    this.deliveryObject.demandName = this.demandName && this.demandName.trim() !== '' ? this.demandName : null;

    SurveyService.createLinkSurvey(this.deliveryObject).then(() => {
      surveyData.linkSurvey = this.deliveryObject.link;
      SurveyService.createEmailSurvey(surveyData).then(() => {
        snackBarService.successMessage(this.$t('emailSentSuccessfully'));
        window.location.reload();
        this.delayedAction();
      }).catch((err: any) => {
        snackBarService.errorMessage(err.response.data.messages);
        this.delayedAction();
      });
    }).catch(() => {
      snackBarService.errorMessageToString(this.$t('errorCreatingSurveyLink'));
      this.delayedAction();
    });
  }

  private updateDeliverables(): void {
    this.deliveryObject.id = this.generateUUID();
    this.deliveryObject.deliverables = this.workItemsSelectedList.map(it => ({
      id: it.id,
      name: it.title,
    }));
    this.deliveryObject.expirationDate = this.calculateValidityDate();
  }

  private addToSelectedList(item: WorkItemSummary): void {
    if (!this.workItemsSelectedList.some(i => i.id === item.id)) {
      this.workItemsSelectedList = [...this.workItemsSelectedList, item];
    }
    this.updateDeliverables();
  }

  private removeFromSelectedList(item: WorkItemSummary): void {
    this.workItemsSelectedList = this.workItemsSelectedList.filter(i => i.id !== item.id);
    const found = this.workItems.find(i => i.id === item.id);
    if (found) this.$set(found, 'isSelected', false);
    this.updateDeliverables();
  }

  private getWorkItemsSelectedQuantity(): number {
    return this.workItems.filter(item => item.isSelected).length;
  }

  private calculateValidityDate(): Date {
    const currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() + 6);

    return currentDate;
  }

  private addRecipient(): void {
    this.surveyData.pushNewRecipient();
  }

  private removeRecipient(index: number): void {
    this.surveyData.removeRecipient(index);
  }

  private toggleSelectAll(): void {
    if (this.selectAll) {
      this.workItems.forEach((item) => {
        this.$set(item, 'isSelected', true);
      });
      const selectedIds = new Set(this.workItemsSelectedList.map(i => i.id));
      const toAdd = this.workItems.filter(i => !selectedIds.has(i.id));
      this.workItemsSelectedList = [...this.workItemsSelectedList, ...toAdd];
    } else {
      this.workItems.forEach((item) => {
        this.$set(item, 'isSelected', false);
      });
      this.workItemsSelectedList = [];
    }
    this.updateSelectedWorkItems += 1;
    this.surveyData.workItems = this.workItems.map(it => it.id);
    this.updateDeliverables();
  }

  private getDemandNameOrWorkItemNames(): string {
    if (this.demandName) return this.demandName;
    return this.selectedWorkItems.map(it => it.title).join('<br/>');
  }

  private formatDeliveryDate(date: string | undefined): string | undefined {
    if (!date) return undefined;
    const splitted = date.split('-');
    return `${splitted[2]}/${splitted[1]}/${splitted[0]}`;
  }

  get assignedToList() {
    if (!this.filterFields) return [];
    return this.filterFields.memberUsernames;
  }

  get parsedDeliveryDateFrom(): string | undefined {
    return this.formatDeliveryDate(this.deliveryDateFrom);
  }

  get unparsedDeliveryDateFrom(): string | undefined {
    return this.deliveryDateFrom;
  }

  get parsedDeliveryDateTo(): string | undefined {
    return this.formatDeliveryDate(this.deliveryDateTo);
  }

  get unparsedDeliveryDateTo(): string | undefined {
    return this.deliveryDateTo;
  }

  get projectControlNameSelected(): string | undefined {
    return this.projectControlName !== '' ? this.projectControlName : undefined;
  }

  get selectedWorkItems() {
    return this.workItemsSelectedList;
  }

  loadWorkItems(): void {
    if (!this.projectId) {
      return;
    }
    this.loadingWorkItems = true;
    WorkItemService.searchAllAggregatorWorkItems(
      this.unparsedDeliveryDateFrom,
      this.unparsedDeliveryDateTo,
      this.projectId,
      this.projectControlNameSelected,
      this.assignedToIds,
    )
      .then((resp: WorkItemSummary[]) => {
        const selectedIds = new Set(this.workItemsSelectedList.map(i => i.id));
        this.workItems = resp
          .map(item => ({
            ...item,
            isSelected: selectedIds.has(item.id),
          })) as SelectableWorkItemSummary[];
        if (this.projectControlNameList.length === 0) {
          this.projectControlNameList = [...new Set(resp.map(item => item.projectControlName)
            .filter(item => item !== null))];
        }
        if (this.shouldReloadAssignedTo) {
          this.workItemsSaved = this.workItems;
          this.shouldReloadAssignedTo = false;
        }
      })
      .finally(() => {
        this.loadingWorkItems = false;
      });
  }

  get projectList() {
    return this.projectsStore.getAllProjectsUser;
  }

  get handleProjectControlNameList() {
    return this.projectControlNameList;
  }

  get handleWorkItemUserNames() {
    return [...new Set(this.workItemsSaved
      .filter(workitem => workitem.assignedTo)
      .map(workitem => workitem.assignedTo.userName))].sort();
  }

  private getWorkItemByAssignedToName(userNames: string[]) {
    return this.workItemsSaved.filter(workitem => workitem.assignedTo
            && userNames.includes(workitem.assignedTo.userName));
  }

  private changeCheckBox(value: boolean): void {
    this.surveyData.singleDelivery = value;
    if (value) {
      this.oldDemandName = this.demandName;
      this.demandName = '';
      this.disableDeliveryName = true;
      return;
    }
    this.disableDeliveryName = false;
    this.demandName = this.oldDemandName;
  }

  private confirmEmailSend(): void {
    this.dialogModal = true;
  }

  private cancel(): void {
    this.dialogModal = false;
  }

  private sendEmail(): void {
    this.dialogModal = false;
    this.executeEmailSend();
  }

  private delayedAction(): void {
    setTimeout(() => {
      this.isCopyLinkButtonDisabled = false;
    }, 2000);
  }
}
